export enum ClientType {
  OWNER = "Propriétaire exploitant",
  PROPERTY_MANAGER = "Gestionnaire Immobilier",
  CO_OWNERSHIP_MANAGER = "Gestionnaire de copropriété ou syndic",
  HEALTH = "Santé",
  PRESCRIPTOR = "Prescripteur",
  HOSTEL_RESTAURANT = "Hôtellerie_restauration",
  TEACHING = "Propriétaire/Gestionnaire d'un établissement d'enseignement",
  STUDY_DESK = "Bureau d'étude",
  ARCHITECT = "Architecte/BET",
  BUILDING_PROFESSIONAL = "Professionnel du bâtiment",
  DEMO = "Compte démo 👀",
  OTHER = "Autre",
}

export const CLIENT_TYPES = Object.values(ClientType) as [
  ClientType,
  ...ClientType[],
];

export const CLIENT_TYPES_LABELS: Record<
  ClientType,
  { label: string; value: ClientType; visibleInApp: boolean }
> = {
  [ClientType.OWNER]: {
    value: ClientType.OWNER,
    visibleInApp: true,
    label: "Propriétaire exploitant",
  },
  [ClientType.PROPERTY_MANAGER]: {
    value: ClientType.PROPERTY_MANAGER,
    visibleInApp: true,
    label: "Gestion d'actifs immobiliers",
  },
  [ClientType.CO_OWNERSHIP_MANAGER]: {
    value: ClientType.CO_OWNERSHIP_MANAGER,
    visibleInApp: false,
    label: "Gestion de copropriété ou Syndic",
  },
  [ClientType.HEALTH]: {
    value: ClientType.HEALTH,
    visibleInApp: true,
    label: "Santé",
  },
  [ClientType.PRESCRIPTOR]: {
    value: ClientType.PRESCRIPTOR,
    visibleInApp: false,
    label: "Prescripteur",
  },
  [ClientType.HOSTEL_RESTAURANT]: {
    value: ClientType.HOSTEL_RESTAURANT,
    visibleInApp: true,
    label: "Hôtellerie-Restauration",
  },
  [ClientType.TEACHING]: {
    value: ClientType.TEACHING,
    visibleInApp: true,
    label: "Enseignement",
  },
  [ClientType.STUDY_DESK]: {
    value: ClientType.STUDY_DESK,
    visibleInApp: true,
    label: "Bureau d'étude",
  },
  [ClientType.ARCHITECT]: {
    value: ClientType.ARCHITECT,
    visibleInApp: true,
    label: "Architecture",
  },
  [ClientType.BUILDING_PROFESSIONAL]: {
    value: ClientType.BUILDING_PROFESSIONAL,
    visibleInApp: true,
    label: "Professionnel du bâtiment",
  },
  [ClientType.DEMO]: {
    value: ClientType.DEMO,
    visibleInApp: false,
    label: "Compte démo 👀",
  },
  [ClientType.OTHER]: {
    value: ClientType.OTHER,
    visibleInApp: true,
    label: "Autre",
  },
};

export enum ClientOrigin {
  ONBOARDING = "Formulaire Onboarding Client",
}
export const CLIENT_ORIGINS = Object.values(ClientOrigin) as [
  ClientOrigin,
  ...ClientOrigin[],
];

// Synced with: https://app-eu1.hubspot.com/property-settings/144886321/properties?type=2-130916146&search=stage&action=edit&property=hs_pipeline_stage
export enum ClientStage {
  PROSPECT = "2060166390",
  INITIATION = "2060166391",
  DEVELOPMENT = "2060167357",
  FARMING = "2060167358",
  ACTIVE_BRONZE = "2151154926",
  ACTIVE_SILVER = "2151154927",
  ACTIVE_GOLD = "2151154928",
  LOST = "2060167359",
}
export const CLIENT_STAGES = Object.values(ClientStage) as [
  ClientStage,
  ...ClientStage[],
];
